export enum AuthStatus {
    LOGGED_IN = 'logged-in',
    NEW_USER = 'new-user',
    NEW_PROVIDER = 'new-provider',
    WRONG_PROVIDER = 'wrong-provider',
    WRONG_PROVIDER_ID = 'wrong-provider-id',
    LOGIN_ERROR = 'login-error',
    NO_EMAIL = 'no-email'
}

export enum PasswordResetResponse {
    PASSWORD_RESET = 'passwords.reset',
    INVALID_TOKEN = 'passwords.token',
    INVALID_USER = 'passwords.user',
    INVALID_PASSWORD = 'passwords.password'
}

export enum PrintStatus {
    IN_PROGRESS = 'in-progress',
    ERROR = 'error'
}

export interface PrinterHost {
    name: string;
    ip: string;
    pos: string;
}

export type TimeRange = {
    time_start: string;
    time_end: string;
}

export type Availabilities = {
    [key: string]: TimeRange[]
  };

export type District = {
    name: string;
    fee: number | string;
}

export enum TimeOption {
    ASAP = 'asap',
    LATER = 'later'
}

export interface LazyLoadImage {
    desktop: string;
    desktop_2x: string;
    mobile: string;
    mobile_2x: string;
}

export enum IngredientListType {
    MULTI = 'checkbox',
    SINGLE = 'radio',
    AMOUNT = 'number'
}

export interface BackgroundMedia {
    background: string;
    background_2x: string;
}

export interface CardMedia {
    card: string;
    card_2x: string;
}

export interface CustomizerMedia {
    customizer_desktop: string;
    customizer_desktop_2x: string;
    customizer_mobile: string;
    customizer_mobile_2x: string;
}

export type OrderOption = {
    id: string;
    label: string;
    default_value: boolean;
    image_url: string;
};

export type Schedule = {
    name: string;
    start_time: string;
    end_time: string;
    isClosed: boolean;
};

export enum AlertType {
    ERROR = 'error',
    WARNING = 'warning',
    SUCCESS = 'success',
    INFO = 'info'
}

export enum AddressStatusResponse {
    NOT_FOUND = 1,
    EXCEEDED_DISTANCE = 2,
    NOT_STREET_ADDRESS = 3,
    REVALIDATE_ADDRESS = 4
}
